// System dependencies

import Link from "next/link";
import React from "react";

// Application dependencies

import { RouteFields, RouteNames } from "@/interfaces/route.interfaces";
import { manageFormSpinner } from "@/lib/functions";

// Props

interface NavLinkProps {
  displaySpinner?: boolean;
  href?: string;
  label: string;
  onClick?: () => void;
  pageName?: string;
}

const NavLink: React.FC<NavLinkProps> = ({
  displaySpinner = true,
  href = RouteNames[RouteFields.Placeholder].route,
  label,
  onClick,
  pageName = RouteNames[RouteFields.Placeholder].name,
}) => {
  // ---------------------------------------------------------------------------------------------------------------------------------------
  // Form interaction and rendering
  // ---------------------------------------------------------------------------------------------------------------------------------------

  return (
    <div onClick={() => displaySpinner && manageFormSpinner(`loading ${pageName} page - please wait`)}>
      <Link
        className="cursor-pointer whitespace-nowrap text-sm font-semibold text-zinc-900 hover:text-logoblue focus:outline-0 dark:text-zinc-300 dark:hover:text-logoblue-300"
        href={href}
        {...(onClick ? { onClick } : {})}
      >
        {label}
      </Link>
    </div>
  );
};

export default NavLink;
